// var html = document.documentElement;
// var body = document.body;

// var scroller = {
//   target: document.querySelector("#MainContent"),
//   ease: 0.05, // <= scroll speed
//   endY: 0,
//   y: 0,
//   resizeRequest: 1,
//   scrollRequest: 0,
// };

// var requestId = null;

// TweenLite.set(scroller.target, {
//   rotation: 0.01,
//   force3D: true
// });

// window.addEventListener("load", onLoad);

// function onLoad() {    
//   updateScroller();  
//   window.focus();
//   window.addEventListener("resize", onResize);
//   document.addEventListener("scroll", onScroll); 
// }

// function updateScroller() {
  
//   var resized = scroller.resizeRequest > 0;
    
//   if (resized) {    
//     var height = scroller.target.clientHeight;
//     body.style.height = height + "px";
//     scroller.resizeRequest = 0;
//   }
      
//   var scrollY = window.pageYOffset || html.scrollTop || body.scrollTop || 0;

//   scroller.endY = scrollY;
//   scroller.y += (scrollY - scroller.y) * scroller.ease;

//   if (Math.abs(scrollY - scroller.y) < 0.05 || resized) {
//     scroller.y = scrollY;
//     scroller.scrollRequest = 0;
//   }
  
//   TweenLite.set(scroller.target, { 
//     y: -scroller.y 
//   });
  
//   requestId = scroller.scrollRequest > 0 ? requestAnimationFrame(updateScroller) : null;
// }

// function onScroll() {
//   scroller.scrollRequest++;
//   if (!requestId) {
//     requestId = requestAnimationFrame(updateScroller);
//   }
// }

// function onResize() {
//   scroller.resizeRequest++;
//   if (!requestId) {
//     requestId = requestAnimationFrame(updateScroller);
//   }
// }

function addCommas(num) {
  let str = num.toString();
  let arr = str.split('');
  arr.reverse();
  for (let i = 3; i < arr.length; i += 4) {
    arr.splice(i, 0, ',');
  }
  return arr.reverse().join('');
}
function countUp(counter) {
  let target = counter.getAttribute('data-count');
  let current = parseInt(counter.innerText);
  let increment = target / 50;
  if (current < target) {
      counter.innerText = Math.ceil(current + increment);
      setTimeout(() => countUp(counter), 30);
  } else {
    counter.innerText = addCommas(target);
  }  
}

let cloned = false;
let activeele;
function klanimation() {
    let pagescroll = (window.scrollY + 900);
    let sectionactive = document.querySelectorAll('.offset-section');
    if (sectionactive.length > 0) {
        sectionactive.forEach(section => {
            if (pagescroll >= section.offsetTop) {
                section.classList.add('animation-activated')
                // if(section.classList.contains('hydrators-sec')){
                //   section.querySelector('.hydra-heading').setAttribute('style','--wipe:'+ 0 +'%');
                  
                // }
            } else {
                section.classList.remove('animation-activated')
              // if(section.classList.contains('hydrators-sec')){
              //     function counter(){
              //       for(let i = 0; i <= 100; i++){
              //         setTimeout(()=>{ 
              //         i;
              //       },(100*i));
              //      }
              //     }
              //     section.querySelector('.hydra-heading').setAttribute('style','--wipe:'+ counter() +'%');
              //   }
            }
        });
    }
    let alllineitems = document.querySelectorAll('.line-animation > *');
    if (alllineitems.length > 0) {
        alllineitems.forEach(item => {
            // skey text animation
            let parentchildskew = item.closest('.skew-parent.offset-section.animation-activated') != null ? item.closest('.skew-parent.offset-section.animation-activated').querySelectorAll('.line-animation > *'):[];
            if (parentchildskew.length > 0) {
                parentchildskew.forEach((parentitem, index) => {
                    setTimeout(() => {
                        parentitem.parentElement.classList.add('line-animate-skew');
                        if(parentitem.parentElement.classList.contains('hydra-row') && parentitem.parentElement.classList.contains('line-animate-skew')) {
                          //console.log('parentitem => ', parentitem.parentElement)
                          if(!parentitem.parentElement.classList.contains('active')) {
                            parentitem.parentElement.classList.add('active')
                            let counters = parentitem.parentElement.querySelectorAll('.counter')
                            counters.forEach((counter) => {
                              countUp(counter)
                            })
                          }
                          
                        }
                    }, (200 * index));
                });
            }

            // offset text animation 
            let parentchildoffset = item.closest('.opacity-text-parent.animation-activated') != null ? item.closest('.opacity-text-parent.animation-activated').querySelectorAll('.line-animation > *'):[];
            if (parentchildoffset.length > 0) {
                parentchildoffset.forEach((parentoffsetitem, index2) => {
                    if(pagescroll >= parentoffsetitem.offsetTop){
                        setTimeout(() => {
                            parentoffsetitem.parentElement.classList.add('line-animate-opacity');
                        }, (200 * index2));
                    }else{
                       parentoffsetitem.parentElement.classList.remove('line-animate-opacity'); 
                    }
                });
            }
        });
    }

    // left right box animation
    // let left_right_boxes = document.querySelectorAll('.box-right-left');
    // if(left_right_boxes.length > 0){
    //     left_right_boxes.forEach(box=>{
    //         let boxes = box.closest('.animation-activated.box-right-left-parent') != null ? box.closest('.animation-activated.box-right-left-parent').querySelectorAll('.box-right-left > *') : [];
    //         if(boxes.length > 0){
    //             boxes.forEach((boxitem,index)=>{
    //                 let sectionscroll = (pagescroll - boxitem.offsetTop);
    //                 let totalscroll = boxitem.offsetTop - boxitem.closest('.animation-activated.box-right-left-parent').offsetTop;  
    //                 if((index+1)%2 == 0 && (index+1) != 1){
    //                     if((50 - ((sectionscroll/totalscroll)*50) ) >= 0){
    //                     boxitem.setAttribute('style','transform:translateX('+ (50 - ((sectionscroll/totalscroll)*50) ) +'%); opacity:'+ (sectionscroll/totalscroll)+';');
    //                     }else{
    //                         boxitem.setAttribute('style','transform:translateX(0%); opacity:1;')
    //                     }
    //                 }else{
    //                     if((50 - ((sectionscroll/totalscroll)*50) ) >= 0){
    //                     boxitem.setAttribute('style','transform:translateX(-'+ (50 - ((sectionscroll/totalscroll)*50) ) +'%); opacity:'+(sectionscroll/totalscroll)+';')
    //                     }else{
    //                         boxitem.setAttribute('style','transform:translateX(0%); opacity:1;')
    //                     }
    //                 }
    //             })
    //         }
    //     })
    // }

    // background scale animation 
    let bg_box = document.querySelectorAll('.bg-image-animation');
    if(bg_box.length > 0){
        bg_box.forEach(bg=>{
            if(pagescroll >= bg.offsetTop){
                let totalscroll = (pagescroll - bg.offsetTop);
               if(((totalscroll/bg.getBoundingClientRect().height)*100) <= 100){
                bg.style["background-size"] = ""+ (100 - (totalscroll/bg.getBoundingClientRect().height)*100)  +"%";
               }else{
                bg.style["background-size"] = ""+ ((totalscroll/bg.getBoundingClientRect().height)*100) +"%";
               }
            }
        });
    }

    // long skew animation
    let long_skew = document.querySelectorAll('.skew-long-element');
    if(long_skew.length > 0){
        long_skew.forEach((skewitem,index)=>{
            if(pagescroll >= skewitem.offsetTop){
                setTimeout(()=>{
                    skewitem.classList.add('skew-long-animated');
                },(300 * index));
            }else{
                 setTimeout(()=>{
                    skewitem.classList.remove('skew-long-animated');
                },(150 * index));
            }
        });
    }

    // steps animation
    /* let step_wrapper = document.querySelectorAll('.step-animation') 
    if(step_wrapper.length > 0){
        step_wrapper.forEach(step_item=>{
            let all_steps = Array.from(step_item.querySelectorAll('.step_item'));
            let activeelement = step_item.querySelector('.step_item');
            let filterstep = all_steps.filter(filter_step=>{
                if(filter_step.parentElement.getAttribute('class') != 'preview-item'){
                    return true;
                }
            })
            if(filterstep.length > 0){
                filterstep.forEach(step=>{
                    if(pagescroll >= step.offsetTop){
                            if( activeele == undefined ){
                                activeele = step.cloneNode(true);
                                step_item.querySelector('.preview-item').innerHTML = "";
                                step_item.querySelector('.preview-item').appendChild(activeele);
                            }
                            else if(activeele.getAttribute('class') != step.getAttribute('class') ){
                                activeele = step.cloneNode(true);
                                step_item.querySelector('.preview-item').innerHTML = "";
                                step_item.querySelector('.preview-item').appendChild(activeele);
                            }
                            step.querySelectorAll('.step-details').forEach((details_item,index)=>{
                               if(pagescroll >= (step.offsetTop + details_item.offsetTop) ){
                                    let getdata_id = details_item.dataset.id;
                                    let activated_list = document.querySelectorAll('.step-details[data-id="'+ getdata_id +'"]');
                                    if(activated_list.length > 0){
                                        activated_list.forEach(list=>{
                                            list.classList.add('detail-active');
                                        })
                                    }
                               }
                            });
                    }
                });
            }
        });
    } */
    

}
document.addEventListener('scroll', function() {
    klanimation()
});
window.onload = function() {
    klanimation()
}
$(document).ready(function(){
  if($(window).width() < 767){
    /* $('.bottle-shop-row').slick({
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
    }); */
  }

  let customBtn = document.querySelector('.product-form__submit.custom-btn')
  let customBtnSubscribe = document.querySelector('.product-form__submit.custom-btn-subscribe')
  let customBtnPurchase = document.querySelector('.product-form__submit.custom-btn-purchase')
  let termsCheckBox = document.querySelector('#acceptTermsAndConditions')
  if(customBtn && termsCheckBox) {
    customBtn.addEventListener('click', (e) => {
        e.preventDefault()
        if(!termsCheckBox.checked) {
            document.querySelector('button.product-form__submit.button').click()
        }else {
            window.location.href = customBtn.href
        }
    })
  }

  if(customBtnSubscribe) {
    customBtnSubscribe.addEventListener('click', (e) => {
        e.preventDefault()
        /* document.querySelector('.shopify_subscriptions_app_block_label:last-child ul label').click() */
        const parentForm = e.target.closest('form');
        const submitButton = parentForm ? parentForm.querySelector('button.product-form__submit.button') : null;
        if (submitButton) {
          submitButton.dataset.type = "cart";
          setTimeout(() => {
            submitButton.click()
          }, 100)
        }
    })
  }

  if(customBtnPurchase) {
    customBtnPurchase.addEventListener('click', (e) => {
        e.preventDefault()
        /* document.querySelector('.shopify_subscriptions_app_block_label:first-child label').click() */
        const parentForm = e.target.closest('form');
        const submitButton = parentForm ? parentForm.querySelector('button.product-form__submit.button') : null;
        if (submitButton) {
          submitButton.dataset.type = "checkout";
          setTimeout(() => {
            submitButton.click()
          }, 100)
        }
    })
  }

  if(document.querySelector('.shopify_subscriptions_fieldset')) {
    document.querySelectorAll('.shopify_subscriptions_fieldset').forEach((field) => {
      field.querySelector('.shopify_subscriptions_app_block_label:last-child ul label').click()
    })
  }
});
